'use strict';
/* eslint-disable no-param-reassign */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _underscore = require('underscore');

var _images = require('conversations-core/constants/images');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getNotificationBody(messages) {
  if (messages.length === 0) {
    return '';
  }

  return messages.map(_ConversationalMessageModel.getText).join('\n');
}

function getNotificationTitle(visitor) {
  if (!visitor.vid) {
    return _I18n2.default.text('notifications.title.default');
  }

  var email = visitor.email,
      firstName = visitor.firstName,
      lastName = visitor.lastName;


  var identifier = _I18n2.default.SafeString((0, _underscore.compact)([firstName, lastName]).join(' ') || email);

  return _I18n2.default.text('notifications.title.withIdentity', { identifier: identifier });
}

function getNotificationOptions(channel, visitor, newMessage, messages) {
  var avatar = visitor.vid ? visitor.avatar : null;
  var options = {
    body: getNotificationBody(messages),
    icon: avatar || _images.defaultNotificationAvatar,
    tag: '' + channel,
    silent: true
  };

  return options;
}

function destroyNotification(notificationData) {
  notificationData.notification.close();
  clearTimeout(notificationData.notificationTimeout);
  notificationData.messages = [];
  notificationData.notificationTimeout = null;
}

var NotificationFactory = function () {
  function NotificationFactory() {
    _classCallCheck(this, NotificationFactory);

    this.notifications = {};
  }

  _createClass(NotificationFactory, [{
    key: 'buildNotificaiton',
    value: function buildNotificaiton(channel, visitor, message, onClick) {
      var _this = this;

      Notification.requestPermission(function () {
        var _ref = _this.notifications[channel] || {},
            _ref$messages = _ref.messages,
            messages = _ref$messages === undefined ? [] : _ref$messages;

        var _ref2 = _this.notifications[channel] || {},
            notification = _ref2.notification,
            notificationTimeout = _ref2.notificationTimeout;

        messages.unshift(message);

        if (notification) {
          notification.close();
        }

        if (notificationTimeout) {
          clearTimeout(notificationTimeout);
        }

        var options = getNotificationOptions(channel, visitor, message, messages);
        var title = getNotificationTitle(visitor);
        notification = new Notification(title, options);

        notification.onclick = function () {
          destroyNotification(_this.notifications[channel]);
          onClick();
        };

        notificationTimeout = setTimeout(function () {
          destroyNotification(_this.notifications[channel]);
        }, 5000);

        _this.notifications[channel] = {
          notification: notification,
          notificationTimeout: notificationTimeout,
          messages: messages
        };
      });
    }
  }]);

  return NotificationFactory;
}();

exports.default = NotificationFactory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/notifications/NotificationFactory.js
// module id = 491
// module chunks = 0